import { Injectable } from '@angular/core';
import { filter, fromEvent, map, Observable } from 'rxjs';

import { NgxStorageEvent } from '../models/dto';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private changes: Observable<NgxStorageEvent>;

  constructor() {
    this.changes = fromEvent<StorageEvent>(window, 'storage')
      .pipe(
        filter((event: StorageEvent) => event.storageArea == localStorage && !!event.newValue),
        map((event: StorageEvent) => { return { key: event.key, value: JSON.parse(event.newValue) } as NgxStorageEvent })
      );
  }

  private getKey(key: string): string {
    return 'ngx_' + key;
  }

  get(key: string): any {
    if (!!key) {
      let value = localStorage.getItem(this.getKey(key));

      if (value != null) {
        return JSON.parse(value);
      }
    }

    return null;
  }

  set(key: string, value: any, forceChange: boolean = false) {
    if (!!key) {
      if (value != null) {
        if (forceChange && this.get(key) != null) {
          this.remove(key);
        }

        localStorage.setItem(this.getKey(key), JSON.stringify(value));
      } else {
        this.remove(key);
      }
    }
  }

  remove(key: string) {
    if (!!key) {
      localStorage.removeItem(this.getKey(key));
    }
  }

  observe(key: string): Observable<any> {
    return this.changes
      .pipe(
        filter((event: NgxStorageEvent) => !!key ? event.key == this.getKey(key) : false),
        map((event: NgxStorageEvent) => event.value)
      );
  }
}